import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'crop-3-2-filled', 'Crop32Filled', [["path",{"d":"M18 6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z"}]]);